import React from "react";
import identify from "~/identify";
import { connectedField } from "~/ui/Fields/VariadicField/connectedField";
import { OptionsManager, remoteSource, localSource, renderHTML } from "~/native-ui";
import { Chip } from "./Chip";
import keyBy from "lodash/keyBy";

const ConnectedSelectChip = connectedField(React.forwardRef(({multiSelect, ...props}, ref) => {
    const {filterValue, title, isAutocomplete, value, } = props,
          normalizedQuery = () => props.query ? props.query : '',
          normalizeText = (str) => str.replace(/(<([^>]+)>)/gi, ""),
          isLoading = () => props.isAutocomplete && props.autocomplete.status === identify.STATUS_STARTED,
          getSource = () => {
            let { trans } = props,
                source  = props.isAutocomplete ?
                remoteSource(props, normalizedQuery()) :
                localSource(props, normalizedQuery());

            if(source.length < 1 && isLoading()) {
                return [{text: trans('loadingPlaceholder'), disabled: true, value: 'system_loading'}];
            }

            if(source.length < 1) {
                return [{text: trans('noItems'), disabled: true, value: 'system_empty'}];
            }

            return source;
          },
          selectedValues = (() => {
            const values = [].concat(filterValue?.value).filter(Boolean);
            if (!values.length) return values;

            const source = keyBy(getSource(), "value");
            return values.map((key) => source[key]?.text).filter(Boolean);
          })(),
          [selectedFilterValue, ...otherValues] = selectedValues,
          selectedFilterValueStr = !selectedFilterValue ? title : !otherValues.length ? `${title}: ${selectedFilterValue}` : `${title}: ${selectedFilterValue} +${otherValues.length}`,
          tooltip = !selectedFilterValue ? "" : normalizeText(`${title}: ${selectedValues.join(", ")}`),
          label = normalizeText(selectedFilterValueStr),
          icon = multiSelect ? "order-bool-ascending-variant" : "order-bool-ascending";

    const chipProp = {
        icon,
        iconFamily: "material-community",
        ...props,
        tooltip,
        title: label,
    }

    if (isAutocomplete && selectedValues.length) {
        return (
            <OptionsManager { ...props } { ...value } source={getSource()}>
                <Chip ref={ref} { ...chipProp } />
            </OptionsManager>
        )
    }


    return <Chip ref={ref} { ...chipProp } />
}));


export const SelectChip = React.forwardRef((props, ref) => {
    return <ConnectedSelectChip ref={ref} { ...props } name={props.name} inputType={identify.FILTERFIELD} />
})